<script setup>
import { modalController } from "@ionic/vue";
import { defineProps, ref } from "vue";

const props = defineProps(["childMenus","subChapterId"]);

const handleClose = function () {
  modalController.dismiss();
};

const handleItem = function (subChapterId) {
  modalController.dismiss({ subChapterId: subChapterId });
};
</script>

<template>
  <div class="menu-wrapper">
    <div class="menu-wrapper_title">
      <span>章节目录</span>
      <img src="@/assets/grammar/icon-close.svg" alt="" @click="handleClose" />
    </div>
    <ul class="menu-wrapper_list">
      <li
        v-for="(item, index) in props.childMenus"
        :key="index"
        @click="handleItem(item.subChapterId)"
      >
        <span :class="props.subChapterId === item.subChapterId ? 'active' : ''">{{ item.pageTitle }}</span>
        <div class="page-item">
          <span>{{ item.pageNumber }}</span>
          <img class="icon-next" src="@/assets/grammar/icon-next.svg" alt="" />
        </div>
        <img v-if="props.subChapterId === item.subChapterId" class="icon-learning" src="@/assets/grammar/icon-learning.svg" alt="">
      </li>
    </ul>
  </div>
</template>

<style scoped lang="less">
.menu-wrapper {
  padding: 0.84rem 1rem;
  height: 100%;

  &_title {
    display: flex;
    justify-content: space-between;
    font-size: 1.08rem;
    padding-bottom: 0.3rem;

    img {
      width: 1.68rem;
      height: 1.68rem;
    }
  }

  &_list {
    padding: 1rem 0 1rem;
    margin: 0;
    overflow-y: auto;
    height: 100%;

    li {
      display: flex;
      justify-content: space-between;
      color: rgba(51, 51, 51, 0.65);
      font-size: 1rem;
      line-height: 1.35rem;
      border-bottom: 1px dashed rgba(51, 51, 51, 0.3);
      padding: 0.67rem 0;
      position: relative;

      .icon-next {
        width: 1rem;
        height: 1rem;
        margin-left: 0.67rem;
      }

      .page-item {
        display: inline-flex;
        align-items: center;
      }

      .active {
        color: #0dcb8b;
      }

      .icon-learning{
        width: 3.51rem;
        height: 2.22rem;
        position: absolute;
        right: 2rem;
        top: -1rem;
      }
    }
  }
}
</style>
